import HttpRequestRotoBrain from "../../Services/HttpRequestRotoBrain";
import { useQuery } from "@tanstack/react-query";

export const getRankingThisWeeks = async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: "/rankings_this_weeks",
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const useRankingThisWeeks = () => {
  return useQuery({
    queryKey: ["getRankingThisWeeks"],
    queryFn: getRankingThisWeeks,
    staleTime: 15 * 60 * 1000, //15 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
};

export const getRankingSeasonLeaders = async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: "/ranking_season_leaders",
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const useRankingSeasonLeaders = () => {
  return useQuery({
    queryKey: ["getRankingSeasonLeaders"],
    queryFn: getRankingSeasonLeaders,
    staleTime: 15 * 60 * 1000, //15 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
};

export const getRanking2024Season = async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: "/v1/rankings_2024_season",
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const useRanking2024Season = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["getRanking2024Season"],
    queryFn: getRanking2024Season,
    staleTime: 15 * 60 * 1000, //15 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    enabled: options?.enabled !== false, // Default to true if not specified
  });
};

export const getRanking2025Season = async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: "/v1/rankings_2025_season",
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};


export const useRanking2025Season = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["getRanking2025Season"],
    queryFn: getRanking2025Season,
    staleTime: 15 * 60 * 1000, //15 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    enabled: options?.enabled !== false, // Default to true if not specified
  });
};


export const getPlayerIdByName = async (name:string |  undefined) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: `/v1/rankings_2025_season/search?search=${name}&limit=1`,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};